<template>
  <nav aria-label="Page navigation example">
    <ul class="pagination">
      <li class="page-item" v-if="isFirst">
        <a
          class="page-link"
          href="#"
          aria-label="Previous"
          @click.prevent="goPrevPage"
        >
          <span aria-hidden="true">&laquo;</span>
          <span class="sr-only">Previous</span>
        </a>
      </li>
      <li class="page-item" v-if="showFirst">
        <a class="page-link" href="#" @click.prevent="changePage(1)">1</a>
      </li>

      <li class="page-item" v-if="hasFirstDiff">
        <a class="page-link" href="#" @click.prevent>…</a>
      </li>

      <li
        class="page-item"
        :class="{ active: n + showMin - 1 === page }"
        v-for="n in showMax - showMin + 1"
        :key="n + showMin - 1"
      >
        <a
          class="page-link"
          href="#"
          @click.prevent="changePage(n + showMin - 1)"
          >{{ n + showMin - 1 }}</a
        >
      </li>

      <li class="page-item" v-if="hasLastDiff">
        <a class="page-link" href="#" @click.prevent>…</a>
      </li>

      <li class="page-item" v-if="showLast">
        <a class="page-link" href="#" @click.prevent="changePage(maxPage)">{{
          maxPage
        }}</a>
      </li>
      <li class="page-item" v-if="isLast">
        <a
          class="page-link"
          href="#"
          aria-label="Next"
          @click.prevent="goNextPage"
        >
          <span aria-hidden="true">&raquo;</span>
          <span class="sr-only">Next</span>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    page: { type: Number, required: true },
    perPage: { type: Number, required: true },
    number: { type: Number, required: true },
    span: { type: Number, default: 2 }
  },

  computed: {
    maxPage() {
      return Math.ceil(this.number / this.perPage);
    },
    showMin() {
      let min = this.page - this.span;
      return min >= 1 ? min : 1;
    },
    showMax() {
      let max = this.page + this.span;
      return max <= this.maxPage ? max : this.maxPage;
    },
    showFirst() {
      return this.page - this.span > 1;
    },
    hasFirstDiff() {
      return this.showMin > 2;
    },
    isFirst() {
      return this.page > 1;
    },
    showLast() {
      return this.page + this.span < this.maxPage;
    },
    hasLastDiff() {
      return this.maxPage - this.showMax > 1;
    },
    isLast() {
      return this.page < this.maxPage;
    }
  },

  methods: {
    goPrevPage() {
      this.changePage(this.page - 1);
    },
    goNextPage() {
      this.changePage(this.page + 1);
    },
    changePage(number) {
      this.$emit("update:page", number);
    }
  }
};
</script>
